import React, {Component, Fragment} from 'react';
import '../css/CalculatorForm.css';
import FormValidator from '../validation/FormValidator';
import axios from 'axios';
import Disclaimer from './Disclaimer';
import HeatPumpType from './HeatPumpType';
import PostalCode from './PostalCode';
import {provinceSelect, formatData} from '../helpers/functions';
import TextInput from './TextInput';
import CaslCheck from './CaslCheck';
import ImageToggle from './ImageToggle';

class CalculatorForm extends Component {
	constructor(props) {
		super(props);

		this.validator = new FormValidator(props.config.lang);
		this.state = {
			submissionCount: 0,
			currentheating: '',
			lowincome: '',
			province: '',
			firstname: '',
			lastname: '',
			emailaddress: '',
			postalcode: '',
			caslcheck: '',
			heatpumptype: '',
			displayHeatPump: false,
			validation: this.validator.valid()
		};

		this.submitted = false;
		this.handlePostalCode = this.handlePostalCode.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handlePostalCode(event) {
		const regex = new RegExp(/^[abceABCE]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/);
		let value = event.target.value;
		let initial = value.charAt(0).toUpperCase();
		let display = (regex.test(value)) ? true : false;
		let province = (display) ? provinceSelect(initial) : '';
		let heatpumptype = (display) ? this.state.heatpumptype : '';

		this.setState({
			displayHeatPump: display,
			province: province,
			postalcode: value,
			heatpumptype: heatpumptype
		});
	}

	handleChange(event) {
		if (event.target.type !== 'checkbox') {
			event.preventDefault();
			this.setState({
				[event.target.name]: event.target.value
			});
		} else {
			this.setState({
				[event.target.name]: event.target.checked.toString()
			});
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.submitted = true;
		const validation = this.validator.validate(this.state);
		this.setState({validation});

		if (validation.isValid) {
			let count = this.state.submissionCount;
			this.setState({
				submissionCount: count++
			}, () => {
				const result = {
					province: this.state.province,
					heatpumptype: this.state.heatpumptype,
					lowincome: this.state.lowincome
				};

				this.props.addResult(result);
		
				if (!this.props.formSubmitted) {
					// Prepare data for submission.
					const data = formatData(this.state, this.props.config.lang);
					const envUrl = 'https://daikinatlantic.ca/';

					let options = {
						method: 'POST',
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						contentType: false,
						processData: false,
						data: data,
						url: envUrl
					};

					// Fire submission
					axios(options).catch().then();
				}
	
				// Display Results
				this.props.viewResult(true);
	
				// Event for Google Analytics
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({'event' : 'rebateCalcSubmitted'});
			});
		}
	}

	render() {
		let width = this.props.dimensions.width;
		const classes = (width >= 768) ? 'app__responsive-row app__emco-wide' : 'app__responsive-row';
		const envUrl = this.props.config.env === 'dev' ? 'https://sandbox.daikinatlantic.ca/' : '';

		const policyUrl = this.props.config.lang === 'en' ? `${envUrl}privacy-policy/` : `${envUrl}politique-de-confidentialite/?lang=fr`;

		// if the form has been submitted at least once
		// then check validity every time we render
		// otherwise just use what's in state
		let validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;

		return (
			<Fragment>
				<div className="app__form-wrap">
					<form className="app__form" onSubmit={this.handleSubmit} noValidate="noValidate">
						<div className={classes}>
							<div className="app__responsive-wrap app__emco_col_6">
								<TextInput
									label={this.props.content.fnameLabel}
									inputName="firstname"
									validation={validation.firstname}
									handleChange={this.handleChange}
								/>

								<TextInput
									label={this.props.content.lnameLabel}
									inputName="lastname"
									validation={validation.lastname}
									handleChange={this.handleChange}
								/>

								<TextInput
									label={this.props.content.emailLabel}
									inputName="emailaddress"
									validation={validation.emailaddress}
									handleChange={this.handleChange}
								/>

								<PostalCode
									content={this.props.content}
									validation={validation.postalcode}
									handleChange={this.handlePostalCode}
								/>

								<HeatPumpType
									type={this.state.heatpumptype}
									province={this.state.province}
									display={this.state.displayHeatPump}
									content={this.props.content}
									validation={validation.heatpumptype}
									handleChange={this.handleChange}
								/>

								<CaslCheck
									content={this.props.content}
									policyUrl={policyUrl}
									validation={validation.caslcheck}
									handleChange={this.handleChange}
								/>

								<div className="app__responsive-wrap app__form-submit-wrap">
									<input type="submit" value={this.props.content.submitLabel}/>
								</div>
							</div>

							<div className="app__responsive-wrap app__emco_col_6">
								<ImageToggle content={this.props.content.alttags} type={this.state.heatpumptype} />
							</div>

						</div>
					</form>
				</div>
				<Disclaimer config={this.props.config} content={this.props.disclaimer} lang={this.props.config.lang} />
			</Fragment>
		);
	}
}

export default CalculatorForm;



// WEBPACK FOOTER //
// ./src/components/CalculatorForm.js